
import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { EndpointFactory } from '../endpoint-factory.service';
import { ConfigurationService } from '../../services/Common/configuration.service';
import { QuotationPolicyHolder } from '@app/shared/models/business/life/quotation.policyholder.model';
import { NotificationService } from '../../services';
import DataSource from 'devextreme/data/data_source';
import CustomStore from 'devextreme/data/custom_store';
import * as AspNetData from "devextreme-aspnet-data-nojquery";


@Injectable()
export class LifeQuotationEndpoint extends EndpointFactory {
  private readonly _businessSectorUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/Quotation/getbusinesssectors`;
  private readonly _initQuotationUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/Quotation/initquotation`;
  private readonly _getHealthLifeQuotationUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/Quotation/gethealthlifequotation`;
  private readonly _getPolicyHolderUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/Quotation/getquotationpolicyholder`;
  private readonly _getQuotationHeaderUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/Quotation/getquotationheader`;
  private readonly _editPolicyHolderUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/Quotation/initquotation`;
  private readonly _getGovernorateListUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/Quotation/getgovernorates`;
  private readonly _getQuotationBenefitUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/benefit/getquotationbenefit`;
  private readonly _getBenefitsForComparison: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/benefit/getbenefitscomparison`;
  private readonly _getPolicyHolderListUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/Quotation/getpolicyholderlist`;
  private readonly _getBusinessEntitiesUrl: string = `${this.configurations.baseUrl}${this.configurations.smartSuffix}/api/idp/Shared/getbusinessentities`;
  private readonly _getAllQuotationsUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/report/getquotationlist`;
  private readonly _getPendingQuotationsUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/report/getpendingquotations`;
  private readonly _getDraftQuotationsUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/report/getdraftquotations`;
  private readonly _downloadPremuimDocUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/report/downloadpremium`;
  private readonly _downloadPremiumTobDocUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/report/downloadpremiumtob`;
  private readonly _downloadDocUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/report/downlaoddoc`;
  private readonly _downloadTOBDocUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/report/downloadtob`;
  private readonly _downloadUWTCDocUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/report/downloaduwtc`;
  private readonly _createNewOptionUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/Quotation/createnewoption`;
  private readonly _cloneQuotationAsNewInsurerUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/Quotation/clonequotationasnewinsurer`;
  private readonly _quotingInsurerListUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/Quotation/getquotinginsurerlist`;
  private readonly _quotingExpInsurerListUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/Quotation/getExpquotinginsurerlist`;
  private readonly _quotingTPAListUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/Quotation/getquotingtpalist`;
  private readonly _quotationLoadingUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/Quotation/getquotationloading`;
  private readonly _submissionElementsUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/Quotation/getsubmissionelements`;
  private readonly _submitQuotationUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/Quotation/submitforapproval`;
  private readonly _resetClaimsFactorUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/Quotation/resetclaimsfactor`;
  private readonly _submitQuotationWithLoadUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/submitforapprovalwithload`;
  private readonly _draftTermsQuotationUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/draftTermsQuotation`;
  private readonly _getProductsUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/benefit/getproducts`;
  private readonly _submitClaimExpUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/amendclaimexp`;
  private readonly _getClaimExpUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/getclaimexp`;
  private readonly _getOtherBenefitsUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/getotherbenefits`;
  private readonly _getCalculationSummaryUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/getcalculationsummary`;
  private readonly _getViewCalculationSummaryUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/getviewcalculationsummary`;
  private readonly _getClaimExpSummaryUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/getclaimexpsummary`;
  private readonly _getApprovalRequestUrl = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/getapprovalrequest`;
  private readonly _submitApprovalDecisionUrl = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/approvequotation`;
  private readonly _getIndicativePremiumUrl = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/getindicativepremium`;
  private readonly _getQuotationDetailEndpointUrl = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/getquotationdetail`;
  private readonly _getHealthLifeQuotationDetailEndpointUrl = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/gethealthlifequotationdetail`;
  private readonly _getClientRetentionEndpointUrl = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/getclientretention`;
  private readonly _getIndicativePremiumApproverUrl = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/getindicativepremiumforapprover`;
  private readonly _getquotationDocumentsUrl = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/report/getquotationdoclist`;
  private readonly _getquotationDocsByTypeUrl = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/report/getquotationdoctypelist`;
  private readonly _downloadZipUrl = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/report/downloadaszip`;
  private readonly _downloadCoverNotesZipUrl = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/report/downloadcovernotesaszip`;
  private readonly _exportQuoteUrl = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/getquoteexport`;
  private readonly _exportQuoteCensusWithAutoOCUrl = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/getquotecensuswithautooc`;
  private readonly _exportCoverNotesUrl = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/getcovernotes`;
  private readonly _getquotationClaimExpSummaryUrl = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/getquotationclaimexpsummary`;
  private readonly _deleteDocumentUrl = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/deleteclaimdoc`;
  private readonly _deleteApprovalDocumentUrl = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/deleteapprovaldoc`;
  private readonly _deleteQuotationUrl = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/deletequotation`;
  private readonly _confirmQuotationUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/Quotation/confirmquotation`;
  private readonly _quotationBindCoverNotesUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/Quotation/quotationbindcovernotes`;
  private readonly _getNRPLoadingUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/Quotation/getnrploading`;
  private readonly _getSubProductsUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/Quotation/getsubproducts`;
  private readonly _regenerateQuotationDocUrl = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/refreshquotationdoc`;
  private readonly _chronicConditionValueUrl = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/getchronicvalues`;
  private readonly _chronicSubmLimitUrl = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/getchronicsublimits`;
  private readonly _updatechronicConditionUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/updatechroniccondition`;
  private readonly _quotationApprovalCommentUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/Quotation/getapprovalcomment`;
  private readonly _quoteChronicConditionUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/getchroniccondition`;
  private readonly _quotationOtherFeesUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/getquotationotherfees`;
  private readonly _uploadCensusUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/uploadcensus`;
  private readonly _uploadMiscDocsUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/uploadmiscdoc`;
  private readonly _uploadDependentsDocsUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/uploaddependentsdoc`;
  private readonly _uploadWcDocsUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/uploadwcdoc`;
  private readonly _ageBasisUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/shared/getagebasis`;
  private readonly _censusTypeUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/shared/getcensustype`;
  private readonly _coverageTypeUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/shared/getcoveragetype`;
  private readonly _reInsBasisUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/shared/getreinsbasis`;
  private readonly _quotationTypeUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/shared/getquotetype`;
  private readonly _occClassDistTypeUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/shared/getoccclassdisttype`;
  private readonly _documentTypeUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/shared/getdocumenttype`;
  private readonly _saBasisUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/shared/getsabasis`;
  private readonly _getCurrencyUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/shared/getcurrency`;
  private readonly _getNewOptionReasonUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/shared/getnewoptionreason`;
  private readonly _getRenewalDateUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/shared/getrenewaldate`;
  private readonly _getSourceOfGenderUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/shared/getsourceofgender`;
  private readonly _submitAgeBandCensusUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/submitagebandcensus`;
  private readonly _saveCensusInfoUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/saveCensusInfo`;


  private readonly _submitMemberCensusUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/submitmembercensus`;
  private readonly _getCDApproversUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/shared/getcdapprovers`;
  private readonly _addHealthLifeNotificationUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/notification/addhealthlifenotification`;
  private readonly _getSourceQuoteInfoUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/getsourcequoteinfo`;
  private readonly _getHealthLifeNotificationsUrl: string = `${this.configurations.baseUrl}${this.configurations.smartSuffix}/api/idp/notification/gethealthlifenotifications`;

  private readonly _getQuotationCensusInfoEndpointUrl = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/quotation/getQuotationCensusInfo`;


  constructor(http: HttpClient, configurations: ConfigurationService, injector: Injector, private notificationService: NotificationService) {
    super(http, configurations, injector);
  }


  getbusinessSectorEndpoint<T>(tenantId?: number): Observable<T> {
    let endpointUrl = tenantId ? `${this._businessSectorUrl}/${tenantId}` : this._businessSectorUrl;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getbusinessSectorEndpoint(tenantId));
      }));
  }

  getQuotingInsurer(tenantId: number) {
    let endpointUrl = `${this._quotingInsurerListUrl}/${tenantId}`;

    return this.http.get(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.getQuotingInsurer(tenantId));
      }));
  }
  getExpQuotingInsurer(tenantId: number) {
    let endpointUrl = `${this._quotingExpInsurerListUrl}/${tenantId}`;

    return this.http.get(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.getExpQuotingInsurer(tenantId));
      }));
  }


  getQuotingTPA<T>(): Observable<T> {
    let endpointUrl = `${this._quotingTPAListUrl}`;

    return this.http.get(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.getQuotingTPA());
      }));
  }
  getGovernorateList<T>(): Observable<T> {
    let endpointUrl = `${this._getGovernorateListUrl}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => { return this.handleError(error, () => this.getGovernorateList()); }
      ));
  }
  getQuotationLoadingEndpoint<T>(quotationId: number): Observable<T> {
    let endpointUrl = `${this._quotationLoadingUrl}?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getQuotationLoadingEndpoint(quotationId));
      }));
  }
  getQuotationOtherFeesEndPoint<T>(quotationId: number): Observable<T> {
    let endpointUrl = `${this._quotationOtherFeesUrl}?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getQuotationOtherFeesEndPoint(quotationId));
      }));
  }

  submitForApprovalWithLoading<T>(obj: any): Observable<T> {
    return this.http.post(this._submitQuotationWithLoadUrl, JSON.stringify(obj), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.submitForApprovalWithLoading(obj));
      }));
  }

  draftTermsQuotations<T>(obj: any): Observable<T> {
    return this.http.post(this._draftTermsQuotationUrl, JSON.stringify(obj), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.draftTermsQuotations(obj));
      }));
  }

  getIndicativePremium<T>(obj: any): Observable<T> {
    return this.http.post(this._getIndicativePremiumUrl, JSON.stringify(obj), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getIndicativePremium(obj));
      }));
  }
  getIndicativePremiumForApprover<T>(obj: any): Observable<T> {
    return this.http.post(this._getIndicativePremiumApproverUrl, JSON.stringify(obj), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getIndicativePremiumForApprover(obj));
      }));
  }
  resetClaimsFactor<T>(quotationId: number): Observable<T> {
    return this.http.post<T>(this._resetClaimsFactorUrl, JSON.stringify(quotationId), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.resetClaimsFactor(quotationId));
      }));
  }

  getSubmissionElements<T>(quotationId: number): Observable<any> {
    let endpointUrl = `${this._submissionElementsUrl}?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getSubmissionElements(quotationId));
      }));
  }
  getInitQuotationEndpoint<T>(quotationObject: any): Observable<T> {

    return this.http.post<T>(this._initQuotationUrl, JSON.stringify(quotationObject), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getInitQuotationEndpoint(quotationObject));
      }));
  }
  getHealthLifeQuotationEndpoint<T>(sourceQuotationId: number): Observable<T> {
    let endpointUrl = `${this._getHealthLifeQuotationUrl}?sourceQuotationId=${sourceQuotationId}`;

    return this.http.get(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getHealthLifeQuotationEndpoint(sourceQuotationId));
      }));
  }
  uploadCensusEndpoint<T>(censusObject: any): Observable<T> {

    return this.http.post<T>(this._uploadCensusUrl, censusObject).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.uploadCensusEndpoint(censusObject));
      }));
  }
  uploadMiscDocumentEndpoint<T>(miscDocObject: any): Observable<T> {

    return this.http.post<T>(this._uploadMiscDocsUrl, miscDocObject, this.getDocRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.uploadMiscDocumentEndpoint(miscDocObject));
      }));
  }
  uploadDependentsDocumentEndpoint<T>(dependentsDocObject: any): Observable<T> {

    return this.http.post<T>(this._uploadDependentsDocsUrl, dependentsDocObject, this.getDocRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.uploadDependentsDocumentEndpoint(dependentsDocObject));
      }));
  }
  uploadWcDocumentEndpoint<T>(wcDocObject: any): Observable<T> {

    return this.http.post<T>(this._uploadWcDocsUrl, wcDocObject, this.getDocRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.uploadWcDocumentEndpoint(wcDocObject));
      }));
  }
  getEditPolicyHolderEndpoint<T>(formData: QuotationPolicyHolder): Observable<T> {
    return this.http.post(this._initQuotationUrl, JSON.stringify(formData), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getEditPolicyHolderEndpoint(formData));
      }));
  }

  getQuotationHeaderEndPoint<T>(insurerId: any): Observable<any> {
    let endpointUrl = `${this._getQuotationHeaderUrl}/${insurerId}`;

    return this.http.get(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getQuotationHeaderEndPoint(insurerId));
      }));
  }
  getPolicyHolderEndpoint(quotationId: number): Observable<QuotationPolicyHolder> {
    let endpointUrl = `${this._getPolicyHolderUrl}/${quotationId}`;

    return this.http.get(endpointUrl, this.getRequestHeaders()).pipe<QuotationPolicyHolder>(
      catchError(error => {
        return this.handleError(error, () => this.getPolicyHolderEndpoint(quotationId));
      }));
  }

  submitForApprovalEndpoint<T>(quotationId: number): Observable<T> {
    return this.http.post<T>(this._submitQuotationUrl, JSON.stringify(quotationId), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.submitForApprovalEndpoint(quotationId));
      }));
  }
  createNewOptionEndpoint<T>(quotationId: number) {
    return this.http.post<T>(this._createNewOptionUrl, JSON.stringify(quotationId), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.submitForApprovalEndpoint(quotationId));
      }));
  }
  cloneQuotationAsNewInsurerEndpoint<T>(quotationId: number): Observable<T> {
    return this.http.post<T>(this._cloneQuotationAsNewInsurerUrl, JSON.stringify(quotationId), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.cloneQuotationAsNewInsurerEndpoint(quotationId));
      }));
  }
  getQuotationBenefit<T>(quotationId: number): Observable<T> {
    let endpointUrl = `${this._getQuotationBenefitUrl}/${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getQuotationBenefit(quotationId));
      }));
  }
  getBenefitsForComparison<T>(quotationId: number): Observable<T> {
    let endpointUrl = `${this._getBenefitsForComparison}/${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getBenefitsForComparison(quotationId));
      }));

  }
  getProducts<T>(): Observable<T> {
    let endpointUrl = this._getProductsUrl;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getProducts());
      }));

  }
  getQuotationDetailEndpoint<T>(quotationId: number): Observable<T> {
    let endpointUrl = `${this._getQuotationDetailEndpointUrl}?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getQuotationDetailEndpoint(quotationId));
      }));

  }
  getQuotationCensusInfoEndpoint<T>(quotationId: number): Observable<T> {
    let endpointUrl = `${this._getQuotationCensusInfoEndpointUrl}?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getQuotationCensusInfoEndpoint(quotationId));
      }));

  }


  getHealthLifeQuotationDetailEndpoint<T>(sourceQuotationId: number): Observable<T> {
    let endpointUrl = `${this._getHealthLifeQuotationDetailEndpointUrl}?sourceQuotationId=${sourceQuotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getHealthLifeQuotationDetailEndpoint(sourceQuotationId));
      }));
  }
  getClientRetentionEndpoint<T>(quotationId: number): Observable<T> {
    let endpointUrl = `${this._getClientRetentionEndpointUrl}?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getClientRetentionEndpoint(quotationId));
      }));

  }

  getPolicyHolders(tenantId: number): CustomStore {
    return AspNetData.createStore({
      loadParams: { tenantId: tenantId },
      loadUrl: this._getPolicyHolderListUrl,
      onBeforeSend: this.getAuthHeader_devextreme,
      // onBeforeSend: (method, ajaxOptions)=>{
      //   ajaxOptions.headers = this.getRequestHeaders();
      // },
      errorHandler: (error) => {
        this.handleError_devextreme(error);
      }
    });
  }
  getBusinessEntities(entityType: string, tenantId: number): CustomStore {
    return AspNetData.createStore({
      loadParams: { entityType: entityType, tenantId: tenantId },
      key: "id",
      loadUrl: this._getBusinessEntitiesUrl,
      onBeforeSend: this.getAuthHeader_devextreme,
      errorHandler: (error) => {
        this.handleError_devextreme(error);
      }
    });
  }


  // getBusinessSectorList(tenantId: number): CustomStore {
  //     return AspNetData.createStore({
  //         key: "id",
  //         loadParams: { tenantId: tenantId },
  //         loadUrl: this._businessSectorUrl,
  //         onBeforeSend: this.getAuthHeader_devextreme,
  //         errorHandler: function (error) {
  //           this.handleError_devextreme(error);
  //         }
  //     });
  // }
  getAllQuotationList(tenantId: number, statusId: any[]): CustomStore {
    return AspNetData.createStore({
      key: "quotationId",
      loadParams: { tenantId: tenantId, statusId: statusId },
      loadUrl: this._getAllQuotationsUrl,
      onBeforeSend: this.getAuthHeader_devextreme,
      errorHandler: (error) => {
        this.handleError_devextreme(error);
      }
    });

  }
   


  getPendingQuotationList(tenantId: number): CustomStore {
    return AspNetData.createStore({
      key: "quotationId",
      loadParams: { tenantId: tenantId },
      loadUrl: this._getPendingQuotationsUrl,
      onBeforeSend: this.getAuthHeader_devextreme,
      errorHandler: (error) => {
        this.handleError_devextreme(error);
      }
    });
  }
  getMyDraftQuotationList(tenantId: number, statusId: any[]): CustomStore {
    return AspNetData.createStore({
      key: "quotationId",
      loadParams: { tenantId: tenantId, statusId: statusId },
      loadUrl: this._getDraftQuotationsUrl,
      onBeforeSend: this.getAuthHeader_devextreme,
      errorHandler: (error) => {
        this.handleError_devextreme(error);
      }
    });
  }
  downloadTOBEndpoint(quotationId: number): Observable<any> {
    let endpointUrl = `${this._downloadTOBDocUrl}?quotationId=${quotationId}`;

    return this.http.get(endpointUrl, this.getPdfDownloadHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.downloadTOBEndpoint(quotationId));
      }));
  }
  downloadUWTCDocEndpoint(quotationId: number): Observable<any> {
    let endpointUrl = `${this._downloadUWTCDocUrl}?quotationId=${quotationId}`;

    return this.http.get(endpointUrl, this.getPdfDownloadHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.downloadTOBEndpoint(quotationId));
      }));
  }
  downloadPremiumEndpoint(quotationId: number): Observable<any> {
    let endpointUrl = `${this._downloadPremuimDocUrl}?quotationId=${quotationId}`;

    return this.http.get(endpointUrl, this.getPdfDownloadHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.downloadPremiumEndpoint(quotationId));
      }));
  }
  downloadPremiumTobDocEndpoint(quotationId: number): Observable<any> {
    let endpointUrl = `${this._downloadPremiumTobDocUrl}?quotationId=${quotationId}`;

    return this.http.get(endpointUrl, this.getPdfDownloadHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.downloadPremiumTobDocEndpoint(quotationId));
      }));
  }
  downloadDocumentEndpoint(docId: number): Observable<any> {
    let endpointUrl = `${this._downloadDocUrl}?docId=${docId}`;
    return this.http.get(endpointUrl, this.getPdfDownloadHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.downloadDocumentEndpoint(docId));
      }));
  }

  getQuotationClaimExpEndpoint<T>(quotationId: number): Observable<any> {
    let endpointUrl = `${this._getClaimExpUrl}?quotationId=${quotationId}`;

    return this.http.get(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.getQuotationClaimExpEndpoint(quotationId));
      }));
  }

  getQuotationOtherBenefitsEndPoint<T>(quotationId: number): Observable<any> {
    let endpointUrl = `${this._getOtherBenefitsUrl}?quotationId=${quotationId}`;

    return this.http.get(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.getQuotationOtherBenefitsEndPoint(quotationId));
      }));
  }

  getClaimExpSummaryEndpoint<T>(quotationId: number): Observable<any> {
    let endpointUrl = `${this._getClaimExpSummaryUrl}?quotationId=${quotationId}`;

    return this.http.get(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.getClaimExpSummaryEndpoint(quotationId));
      }));
  }
  getCalculationSummaryEndpoint<T>(quotationId: number): Observable<any> {
    let endpointUrl = `${this._getCalculationSummaryUrl}?quotationId=${quotationId}`;

    return this.http.get(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.getCalculationSummaryEndpoint(quotationId));
      }));
  }
  getViewCalculationSummaryEndpoint<T>(quotationId: number): Observable<any> {
    let endpointUrl = `${this._getViewCalculationSummaryUrl}?quotationId=${quotationId}`;

    return this.http.get(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.getCalculationSummaryEndpoint(quotationId));
      }));
  }
  getSubmitClaimExpEndpoint<T>(obj: any): Observable<T> {

    return this.http.post<T>(this._submitClaimExpUrl, JSON.stringify(obj), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getSubmitClaimExpEndpoint(obj));
      }));
  }
  getQuotationClaimExpSummary<T>(quotationId: number): Observable<any> {
    let endpointUrl = `${this._getquotationClaimExpSummaryUrl}?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.getQuotationClaimExpSummary(quotationId));
      }));
  }
  getNRPLoading<T>(quotationId: number): Observable<T> {
    let endpointUrl = `${this._getNRPLoadingUrl}?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.getNRPLoading(quotationId));
      }));

  }
  getApprovalRequestEndPoint<T>(quotationId: number): Observable<T> {
    let endpointUrl = `${this._getApprovalRequestUrl}?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.getApprovalRequestEndPoint(quotationId));
      }));
  }
  submitApprovalDecisionEndPoint<T>(obj: any): Observable<T> {
    return this.http.post<T>(this._submitApprovalDecisionUrl, JSON.stringify(obj), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.submitApprovalDecisionEndPoint(obj));
      }));
  }
  getQuotationDocuments<T>(quotationId: number): Observable<T> {
    let endpointUrl = `${this._getquotationDocumentsUrl}?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.getQuotationDocuments(quotationId));
      }));
  }
  getQuotationDocumentsByType<T>(quotationId: number, docTypeId: string): Observable<T> {
    let endpointUrl = `${this._getquotationDocsByTypeUrl}?quotationId=${quotationId}&docTypeId=${docTypeId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.getQuotationDocumentsByType(quotationId, docTypeId));
      }));
  }
  downloadZipEndpoint<T>(quotationId: number): Observable<T> {
    let endpointUrl = `${this._downloadZipUrl}?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getZipDownloadHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.downloadZipEndpoint(quotationId));
      }));
  }
  downloadCoverNotesZipEndpoint<T>(quotationId: number): Observable<T> {
    let endpointUrl = `${this._downloadCoverNotesZipUrl}?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getZipDownloadHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.downloadCoverNotesZipEndpoint(quotationId));
      }));
  }
  exportQuotationEndpoint<T>(quotationId: number): Observable<T> {
    let endpointUrl = `${this._exportQuoteUrl}?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getExcelDownloadHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.exportQuotationEndpoint(quotationId));
      }));
  }
  exportQuotationCensusWithAutoOCEndpoint<T>(quotationId: number): Observable<T> {
    let endpointUrl = `${this._exportQuoteCensusWithAutoOCUrl}?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getExcelDownloadHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.exportQuotationCensusWithAutoOCEndpoint(quotationId));
      }));
  }
  exportCoverNotesEndpoint<T>(quotationId: number): Observable<T> {
    let endpointUrl = `${this._exportCoverNotesUrl}?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getExcelDownloadHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.exportCoverNotesEndpoint(quotationId));
      }));
  }
  deleteDocument<T>(quotationId: number, docId: number): Observable<T> {
    let endpointUrl = `${this._deleteDocumentUrl}`;

    // var obj = {quotationId:quotationId,docId:docId}
    return this.http.post<T>(endpointUrl,
      JSON.stringify({ quotationId: quotationId, docId: docId }),
      this.getRequestHeaders()).pipe<T>(
        catchError(error => {
          return this.handleError(error, () => this.deleteDocument(quotationId, docId));
        }));
  }
  deleteApprovalDocument<T>(quotationId: number, docId: number): Observable<T> {
    let endpointUrl = `${this._deleteApprovalDocumentUrl}`;

    // var obj = {quotationId:quotationId,docId:docId}
    return this.http.post<T>(endpointUrl,
      JSON.stringify({ quotationId: quotationId, docId: docId }),
      this.getRequestHeaders()).pipe<T>(
        catchError(error => {
          return this.handleError(error, () => this.deleteApprovalDocument(quotationId, docId));
        }));
  }
  deleteQuotation<T>(quotationId: number): Observable<T> {
    let endpointUrl = `${this._deleteQuotationUrl}`;
    return this.http.post<T>(endpointUrl, JSON.stringify(quotationId), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.deleteQuotation(quotationId));
      }));
  }
  regenerateQuotationDoc<T>(quotationNo: string, isComputePremium: boolean): Observable<T> {
    let endpointUrl = `${this._regenerateQuotationDocUrl}`;
    // tslint:disable-next-line: max-line-length
    return this.http.post<T>(endpointUrl, JSON.stringify({ quotationNo: quotationNo, isComputePremium: isComputePremium }), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.regenerateQuotationDoc(quotationNo, isComputePremium));
      }));
  }
  confirmQuotation<T>(quotationId: number): Observable<T> {
    return this.http.post<T>(this._confirmQuotationUrl, JSON.stringify(quotationId), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.confirmQuotation(quotationId));
      }));
  }
  quotationBindCoverNotes<T>(quotationId: number): Observable<T> {
    return this.http.post<T>(this._quotationBindCoverNotesUrl, JSON.stringify(quotationId), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.quotationBindCoverNotes(quotationId));
      }));
  }
  getQuotationApprovalComment<T>(quotationId: number): Observable<T> {
    let endpointUrl = `${this._quotationApprovalCommentUrl}?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.getQuotationApprovalComment(quotationId));
      }));
  }

  getSubProducts<T>(productId: number): Observable<T> {
    let endpointUrl = `${this._getSubProductsUrl}?productId=${productId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => { return this.handleError(error, () => this.getSubProducts(productId)); }
      ));
  }
  getChronicConditionValues<T>(): Observable<T> {
    let endpointUrl = this._chronicConditionValueUrl;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getChronicConditionValues());
      }));
  }
  getChronicSubLimit<T>(): Observable<T> {
    let endpointUrl = this._chronicSubmLimitUrl;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getChronicSubLimit());
      }));
  }
  updateChronicConditionEndPoint<T>(chronicObject: Observable<T>) {
    let endpointUrl = `${this._updatechronicConditionUrl}`;

    return this.http.post<T>(endpointUrl, JSON.stringify(chronicObject), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.updateChronicConditionEndPoint(chronicObject));
      }));
  }

  getQuotationChronicConditions<T>(quotationId: number): Observable<T> {
    let endpointUrl = this._quoteChronicConditionUrl + `?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getQuotationChronicConditions(quotationId));
      }));
  }

  // New End Points

  getAgeBasis<T>(): Observable<T> {
    const endpointUrl = this._ageBasisUrl;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getAgeBasis());
      }));
  }
  getCensusType<T>(): Observable<T> {
    const endpointUrl = this._censusTypeUrl;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getCensusType());
      }));
  }
  getCoverageType<T>(): Observable<T> {
    const endpointUrl = this._coverageTypeUrl;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getCoverageType());
      }));
  }
  getReInsBasis<T>(): Observable<T> {
    const endpointUrl = this._reInsBasisUrl;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getReInsBasis());
      }));
  }
  getQuotationType<T>(): Observable<T> {
    const endpointUrl = this._quotationTypeUrl;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getQuotationType());
      }));
  }

  getCurrency<T>(): Observable<T> {
    const endpointUrl = this._getCurrencyUrl;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getCurrency());
      }));
  }

  getNewOptionReason<T>(): Observable<T> {
    const endpointUrl = this._getNewOptionReasonUrl;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getNewOptionReason());
      }));
  }

  getRenewalDate<T>(): Observable<T> {
    const endpointUrl = this._getRenewalDateUrl;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getRenewalDate());
      }));
  }

  getSourceOfGender<T>(): Observable<T> {
    const endpointUrl = this._getSourceOfGenderUrl;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getSourceOfGender());
      }));
  }

  getOccClassDistType<T>(): Observable<T> {
    const endpointUrl = this._occClassDistTypeUrl;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getOccClassDistType());
      }));
  }
  getDocumentType<T>(): Observable<T> {
    const endpointUrl = this._documentTypeUrl;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getDocumentType());
      }));
  }

  getSABasis<T>(): Observable<T> {
    const endpointUrl = this._saBasisUrl;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getSABasis());
      }));
  }
  submitAgeBandCensusEndpoint<T>(obj: any): Observable<T> {

    // return this.http.post<T>(this._submitAgeBandCensusUrl, obj).pipe<T>(
    return this.http.post<T>(this._submitAgeBandCensusUrl, JSON.stringify(obj), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.submitAgeBandCensusEndpoint(obj));
      }));
  }
  saveCensusInfo<T>(obj: any): Observable<T> {
    return this.http.post<T>(this._saveCensusInfoUrl, JSON.stringify(obj), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.saveCensusInfo(obj));
      }));
  }

  submitMemberCensusEndpoint<T>(obj: any): Observable<T> {
    // return this.http.post<T>(this._submitMemberCensusUrl, obj).pipe<T>(
    return this.http.post<T>(this._submitMemberCensusUrl, JSON.stringify(obj), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.submitMemberCensusEndpoint(obj));
      }));
  }

  getCDApprovers<T>(): Observable<T> {
    const endpointUrl = this._getCDApproversUrl;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getCDApprovers());
      }));
  }

  addHealthLifeNotification<T>(obj: any): Observable<T> {
    return this.http.post(this._addHealthLifeNotificationUrl, JSON.stringify(obj), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.addHealthLifeNotification(obj));
      }));
  }

  getHealthLifeNotificationsDataStore<T>(groupName: string): DataSource<any, any> {
    let endpointUrl = `${this._getHealthLifeNotificationsUrl}?groupName=${groupName}`;

    return new DataSource({
      store: AspNetData.createStore({
        key: 'quotationId',

        loadUrl: endpointUrl,
        onBeforeSend: this.getAuthHeader_devextreme,
        errorHandler: (error) => {
          this.handleError_devextreme(error);
        }
      }),
      sort: [{ selector: 'quotationId', desc: true }],
      paginate: true,
      pageSize: 15,
    });

  }


  getSourceQuoteInfoUrlEndpoint<T>(obj: any): Observable<T> {
    return this.http.post(this._getSourceQuoteInfoUrl, JSON.stringify(obj), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getSourceQuoteInfoUrlEndpoint(obj));
      }));
  }
}
